import React from 'react'
import { ModalConfirm, ModalSizeVariants } from '@labrav/react-components'
import { useFormik } from 'formik'
import * as yup from 'yup'
import { useDispatch } from 'react-redux'

import { Product, ProductStatus } from '../../../modules/productsListing/types'
import { updateProductListingData } from '../../../modules/productsListing/action'
import { urlPattern } from '../../utils/constants'
import {
  productUpdateSnsErrorMessage,
  productUpdateSnsMessage,
} from '../../utils/messagesConstants'
import AddListingFormFields from './AddListingFormFields'

export type FormValues = {
  productCode: string
  productId: string
  productUrl: string
}

interface ProductListingPayload {
  cloudProductCode: string
  cloudProductId: string
  cloudProductUrl: string
  status?: string
}

export const alertMessages = {
  success: productUpdateSnsMessage,
  error: productUpdateSnsErrorMessage,
}

export type AddListingModalProps = {
  modalProductData: Product
  handleClose: () => void
  accountId: string
}

export default function AddListingModal({
  modalProductData,
  handleClose,
  accountId,
}: AddListingModalProps) {
  const dispatch = useDispatch()
  const initialValues: FormValues = {
    productCode: '',
    productId: '',
    productUrl: '',
  }

  const validationSchema = yup.object().shape({
    productCode: yup.string().required('Product Code is required'),
    productId: yup.string().required('Product ID is required'),
    productUrl: yup
      .string()
      .matches(urlPattern, 'Enter correct url')
      .required('Product URL is required'),
  })

  const formik = useFormik<FormValues>({
    initialValues,
    validationSchema,
    onSubmit: async values => {
      handleClose()
      const payload: ProductListingPayload = {
        cloudProductCode: values.productCode,
        cloudProductId: values.productId,
        cloudProductUrl: values.productUrl,
        status: ProductStatus.PRODUCT_STATUS_LABRA_TESTING,
      }

      await dispatch(
        updateProductListingData({
          partnerId: accountId,
          productId: modalProductData.productId,
          data: payload as unknown as Record<string, unknown>,
          alertMessages,
        }) as never
      )
    },
  })

  return (
    <ModalConfirm
      title={'Listing Details'}
      subTitle={''}
      content={
        <AddListingFormFields
          modalProductData={modalProductData}
          formik={formik}
        />
      }
      open={modalProductData ? true : false}
      titleAcceptButton={'Submit'}
      onAccept={formik.handleSubmit}
      onDecline={handleClose}
      variant={ModalSizeVariants.medium}
      acceptDisabled={!(formik.isValid && formik.dirty)}
    />
  )
}
